export default __webpack_public_path__ + "static/media/Thumb_Glasses_03.0003f62f.png";